import { z } from "zod";
import { VALIDATION_MESSAGES_CARD } from "constants/validations";

/**
 * Filters weight input to only allow digits
 */
export const filterWeight = (value: string): string => {
    return value.replace(/\D/g, "");
};

// Weight Schema
export const weightSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .refine(
        (val) => {
            const num = parseInt(val, 10);
            return !isNaN(num) && num >= 50 && num <= 500;
        },
        { message: "Weight must be between 50 and 500 lbs" }
    );

export const optionalWeightSchema = z.union([z.literal(""), weightSchema]).optional();
